import { Box, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

// Style
const useStyles = makeStyles((theme) => ({
  btn_enabled: {
    textTransform: "none",
    whiteSpace: "nowrap",
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    marginLeft: 12,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  btn_disabled: {
    textTransform: "none",
    whiteSpace: "nowrap",
    marginLeft: 12,
    border: "2px solid #e0e0e0",
    backgroundColor: "#e0e0e0",
    color: "#aaa",
  },
}));

// Component
function AmberPrimaryButton(props) {
  const { onClick, text, disabled, testid, ...rest } = props;
  const classes = useStyles();

  function getClassNameByStatus() {
    if (disabled) {
      return classes.btn_disabled;
    }

    return classes.btn_enabled;
  }

  return (
    <Button
      variant="contained"
      onClick={onClick}
      color="primary"
      className={getClassNameByStatus()}
      disabled={disabled}
      data-testid={testid}
      {...rest}
    >
      <Box
        component="span"
        fontSize={14}
        fontWeight={600}
        color="white"
        paddingLeft={1}
        paddingRight={1}
      >
        {text}
      </Box>
    </Button>
  );
}

AmberPrimaryButton.propTypes = {
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  testid: PropTypes.string,
};
AmberPrimaryButton.defaultProps = {
  disabled: false,
  testid: "",
};

export default AmberPrimaryButton;
